import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import CheckMarkIcon from 'images/whitelist-icon.svg'
import VerticalDivider from 'ui/VerticalDivider'

const ProgressBarStep = ({
  index,
  stepNames,
  currentStepIndex,
  stepName,
}: {
  index: number
  stepNames: string[]
  currentStepIndex: number
  stepName: string
}): ReactElement => {
  return (
    <>
      {index !== 0 && (
        <VerticalDivider sx={{ width: '1.6rem', height: '1px', backgroundColor: 'blueYonder50' }} />
      )}

      <Flex
        data-testid={`${index < currentStepIndex ? 'selected' : 'unselected'}-step-${
          stepNames[index]
        }`}
        sx={{
          alignItems: 'center',
          gap: '0.8rem',
        }}
      >
        {index < currentStepIndex && (
          <Svg
            svg={CheckMarkIcon}
            fill="greenApple"
            width="1.6rem"
            height="1.6rem"
            descriptiveText="Completed step"
          />
        )}
        <Text
          sx={{
            fontSize: ['1.4rem', '1.7rem'],
            fontWeight: [400, 500],
            lineHeight: '1.38',

            color:
              index === currentStepIndex
                ? 'aliceBlue'
                : index < currentStepIndex
                ? 'greenApple'
                : 'aliceBlue60',
          }}
        >
          {stepName.charAt(0).toUpperCase() + stepName.slice(1)}
        </Text>
      </Flex>
    </>
  )
}

export default ProgressBarStep
